// extracted by mini-css-extract-plugin
export var bgWord = "OurSpaceSection-module--bgWord--RfYx-";
export var contentContainer = "OurSpaceSection-module--contentContainer--YU1ar";
export var image = "OurSpaceSection-module--image--HUc++";
export var imageWrapper = "OurSpaceSection-module--imageWrapper--JX1Os";
export var imagesContainer = "OurSpaceSection-module--imagesContainer--y72Zm";
export var imagesContainerWrapper = "OurSpaceSection-module--imagesContainerWrapper--TdBkv";
export var mainText = "OurSpaceSection-module--mainText--207V+";
export var section = "OurSpaceSection-module--section--BZ0c3";
export var textContainer = "OurSpaceSection-module--textContainer--hb-Wm";